export default __webpack_public_path__ + "static/media/V5-present.a55042ad.svg";